export default "__VITE_ASSET__BFg8G2s5__"